import React from 'react';
import { Menu } from 'antd';
import {
  DeleteFilled,
  EditFilled,
  EllipsisOutlined,
  SyncOutlined,
} from '@ant-design/icons';
import { Dropdown } from '@/components/AntdCompatDropdown';
import type { CredentialData } from '@/apis/customerCredentials';
import styles from './CredentialRowMenu.module.css';

/** The actions on a credential row's overflow menu. */
export type CredentialRowAction = 'edit' | 'rotate' | 'delete';

interface CredentialRowMenuProps {
  credential: CredentialData;
  onAction: (action: CredentialRowAction, credential: CredentialData) => void;
}

/** The row's overflow menu: Edit, Rotate value, Delete (PRD 4.1). Only
 * rendered for users who may manage credentials. */
const CredentialRowMenu: React.FC<CredentialRowMenuProps> = ({
  credential,
  onAction,
}) => {
  const menu = (
    <Menu
      onClick={({ key }) => onAction(key as CredentialRowAction, credential)}
      items={[
        { key: 'edit', icon: <EditFilled />, label: 'Edit' },
        { key: 'rotate', icon: <SyncOutlined />, label: 'Rotate value' },
        {
          key: 'delete',
          icon: <DeleteFilled />,
          label: 'Delete',
          className: styles.danger,
        },
      ]}
    />
  );

  return (
    <Dropdown overlay={menu} trigger={['click']} placement='bottomRight'>
      <div
        className={styles.trigger}
        role='button'
        aria-label={`Actions for ${credential.name}`}
      >
        <EllipsisOutlined />
      </div>
    </Dropdown>
  );
};

export default CredentialRowMenu;
